/* eslint-disable no-console */
import { mapFarmerToERP } from '@/js/mappers/farmer';
import FarmerRepository from '@/js/repositories/farmerRepository';
import {
  removeFarmer,
  saveFarmer,
} from '@/js/services/contracts/ApiContractsWs';

export default {
  async add(object) {
    object.sync_status = 1;
    await FarmerRepository.add(object);
    return object;
  },

  async updateById(id, objeto) {
    return FarmerRepository.updateById(id, objeto);
  },

  async deleteById(id) {
    const farmer = await this.getById(id);
    if (!farmer.code || farmer.code === '') {
      return FarmerRepository.deleteById(id);
    }
    farmer.sync_status = 2;
    return this.updateById(id, farmer);
  },

  async getById(id) {
    return FarmerRepository.getById(id);
  },

  async getAll() {
    return FarmerRepository.getAll();
  },

  async getFarmersFullInfo(ids) {
    return FarmerRepository.getFarmersFullInfo(ids);
  },

  async getAllSyncPending() {
    return FarmerRepository.getAllSyncPending();
  },

  async saveFarmerToERP(farmer) {
    const farmerERP = mapFarmerToERP(farmer);
    return saveFarmer(farmerERP).then(async (response) => {
      if (response.data.Valor) {
        await this.updateById(farmer.id, { sync_status: 0, code: response.data.Tag.Codigo, sync_error_msg: '' });
      } else {
        console.log('error adding farmer erp', farmer, response.data.Mensaje);
        await this.updateById(farmer.id, { sync_error_msg: response.data.Mensaje });
      }
    }).catch(async (error) => {
      console.log('error adding farmer erp', farmer, error);
      await this.updateById(farmer.id, { sync_error_msg: error });
    });
  },
  async removeFarmerFromERP(farmer) {
    return removeFarmer(farmer).then(async (response) => {
      if (response.data.Valor) {
        await this.deleteById(farmer.id);
      } else {
        console.log('error removing farmer erp', farmer, response.data.Mensaje);
        await this.updateById(farmer.id, { sync_error_msg: response.data.Mensaje });
      }
    }).catch(async (error) => {
      console.log('error removing farmer erp', farmer, error);
      await this.updateById(farmer.id, { sync_error_msg: error });
    });
  },
  async syncPendingFarmers() {
    const syncFarmers = await this.getAllSyncPending();
    for await (const farmer of syncFarmers) {
      if (farmer.sync_status === 1) {
        await this.saveFarmerToERP(farmer);
      } else if (farmer.sync_status === 2) {
        await this.removeFarmerFromERP(farmer);
      }
    }
  },
  async getAllPrimaryKeys() {
    const farmers = await this.getAll();
    return farmers.map((f) => f.code);
  },
};
